/**
 * Resource tab tiền gửi
 * ntduong2 26/4/2023
 */
export default {
  Process: 'Quy trình',
  BaDepositsTab: 'Thu tiền gửi',
  BaWithDrawTab: 'Chi tiền gửi',
  ProcessTab: {
    Deposits: 'Tiền gửi',
    BaDeposits: 'Thu tiền',
    BaWithDraw: 'Chi tiền',
    DepositsNumber: 'Số tiền gửi',
    RevenueNSNNFromKBNN: 'Thu NSNN từ KBNN',
    Report: 'Báo cáo',
    ViewAllReport: 'Xem tất cả báo cáo',
    AdvanceNSNN: 'Bảng kê nộp tiền NSNN',
  },
  BaDeposits: 'Danh sách thu tiền gửi',
  BaWithDraw: 'Danh sách chi tiền gửi',
  InternalTransfer: 'Chuyển tiền nội bộ',
  AdvanceNSNN: 'Danh sách bảng kê nộp tiền NSNN',
  Detail: {
    BaDeposits: 'Phiếu nộp tiền kho bạc',
    BaWithDraw: 'Chi tiền gửi',
    InternalTransfer: 'Chuyển tiền nội bộ',
    AccountSend: 'Người nộp',
    AccountReceive: 'Người nhận',
    Name: 'Họ tên',
    Address: 'Địa chỉ',
    AccountBank: 'TKKB',
    AccountBankTitle: 'Tài khoản kho bạc',
    Description: 'Diễn giải',
    Include: 'Kèm theo',
    VoucherRef: 'CT tham chiếu',
    VoucherRefTitle: 'Chứng từ tham chiếu',
    RefDate: 'Ngày CT',
    RefDateTitle: 'Ngày chứng từ',
    PostedDate: 'Ngày HT',
    PostedDateTitle: 'Ngày hạch toán',
    RefNo: 'Số CT',
    RefNoTitle: 'Số chứng từ',
  },
  GenerateDepositFromAdvanceNSNN: 'Sinh phiếu nộp tiền KB từ Bảng kê nộp tiền NSNN: ',
};
